module.exports = __webpack_public_path__ + "img/z_neko.49895003.jpg";